module.exports = __webpack_public_path__ + "static/media/leading_badge.022f868e.png";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/leading_badge.png
// module id = 235
// module chunks = 0